import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

const SITE_TITLE = "Golden Palms Home Health Care | Rancho Mirage, CA";
const SITE_DESCRIPTION =
  "Compassionate home health care in Rancho Mirage, CA. Golden Palms provides skilled nursing, physical therapy, and wellness services around the clock. Call (760) 318-0000.";

const app = createApp(App);

app.use(router);

router.beforeEach((to, from, next) => {
  document.title = SITE_TITLE;

  const descMeta = document.querySelector('meta[name="description"]');
  if (descMeta) {
    descMeta.setAttribute("content", SITE_DESCRIPTION);
  }

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute("content", SITE_TITLE);
  }

  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) {
    ogDesc.setAttribute("content", SITE_DESCRIPTION);
  }

  next();
});

app.mount("#app");
